"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Slobodan Djordjevic
 */
var Loading = function Loading(_ref) {
  var size = _ref.size,
      color = _ref.color;
  var s = size ? size : "60px";
  var c = color ? color : "#CACACA";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: s,
    height: s,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: c,
    fill: c
  }, /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: "2"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "5",
    cy: "0",
    r: "6"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "cy",
    begin: "0s",
    dur: "2.2s",
    values: "45;10;45;45",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "cx",
    begin: "0s",
    dur: "2.2s",
    values: "10;27;49;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "27",
    cy: "5",
    r: "6"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "cy",
    begin: "0s",
    dur: "2.2s",
    from: "5",
    to: "5",
    values: "10;45;45;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "cx",
    begin: "0s",
    dur: "2.2s",
    from: "27",
    to: "27",
    values: "27;49;10;27",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "49",
    cy: "45",
    r: "6"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "cy",
    begin: "0s",
    dur: "2.2s",
    values: "45;45;10;45",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "cx",
    from: "49",
    to: "49",
    begin: "0s",
    dur: "2.2s",
    values: "49;10;27;49",
    calcMode: "linear",
    repeatCount: "indefinite"
  }))))));
};

exports.Loading = Loading;